"use client";

import { useCallback, useId } from "react";

/**
 * Builds stable `view-transition-name` values for the items of a list.
 *
 * The name must be a page-unique CSS custom-ident, so it is scoped by instance:
 * two mounted copies of the same list (the desktop and mobile layouts of a tab
 * panel, say) would otherwise claim the same names and the browser drops the
 * whole transition. `useId` emits non-ident characters like «:» and item keys
 * are arbitrary, so both are sanitized.
 */
export function useViewTransitionName(prefix: string) {
  const instanceId = useId();

  return useCallback(
    (key: string | number) =>
      `vt-${prefix}-${instanceId}-${key}`.replace(/[^a-zA-Z0-9_-]/g, "_"),
    [instanceId, prefix]
  );
}
